"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenWeatherData = void 0;
const GeoModelCommon_1 = require("../Geo/GeoModelCommon");
const defaultCellLevel = 9;
const objectTypeId = 'OpenWeatherData';
class OpenWeatherData extends GeoModelCommon_1.GeoModelCommon {
    constructor({ ...ob }) {
        super({ cellLevel: defaultCellLevel, ...ob, type: objectTypeId });
        this.weatherData = ob.weatherData;
        this.cached = ob.cached ?? false;
    }
    getTimestampMs() {
        return this.weatherData?.timestamp ? this.weatherData?.timestamp * 1000 : undefined;
    }
}
exports.OpenWeatherData = OpenWeatherData;
